import React from "react";

const OTPVerify = ({
  modValues,
  setModValues,
  onClickResend,
  onClickSubmit,
}) => {
  const { otp } = modValues || {};

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(
      2,
      "0"
    )}:${String(secs).padStart(2, "0")}`;
  };

  return (
    <div className="otp-verification">
      <div className="otp-box">
        <div className="otp-box-input">
          <label
            htmlFor="otp"
            className={`formInputLabel ${
              otp?.length !== 7 ? "error-label" : "pass-label"
            }`}
          >
            {otp?.length !== 7 ? "OTP Must Be 7 Digit" : "7 Digit Entered"} (
            {otp?.length})
          </label>

          <input
            type="number"
            placeholder="Enter 7 Digit OTP"
            className={`formInput`}
            name="otp"
            value={otp}
            onChange={(e) =>
              setModValues((prevs) => ({
                ...prevs,
                otp: e.target.value,
              }))
            }
            min={0}
            max={7}
          />
        </div>
      </div>

      <div className="otp-timer">
        {modValues.timerCount ? (
          <span className="resend-code">
            Resend Code in <b>{formatTime(modValues.timerCount)}</b>
          </span>
        ) : (
          <button
            type="button"
            className="sumit-btn resend-btn"
            onClick={onClickResend}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-left"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
              />
            </svg>
            resend
          </button>
        )}

        {otp?.length === 7 ? (
          <button type="button" className="sumit-btn" onClick={onClickSubmit}>
            submit
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default OTPVerify;
